// extracted by mini-css-extract-plugin
export default {"card":"ToolsPage_card__sbWec","title":"ToolsPage_title__2iJxu","liveTool":"ToolsPage_liveTool__T4rFV"};